import { c as _c } from "react/compiler-runtime";
import { useMutation, useQuery, type UseMutationResult, type UseQueryResult } from '@tanstack/react-query';
import type * as fetch from 'shared/api/fetch';
import * as mimir from 'shared/api/mimir';
export const useQueryMimirSearch = props => {
  const $ = _c(7);
  let t0;
  let t1;
  if ($[0] !== props) {
    t0 = ["mimirAgentSearch", props.clientId, props.agentId, props.query, props];
    t1 = async () => await mimir.agentSearch(props);
    $[0] = props;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  const t2 = Boolean(props.clientId) && props.agentId !== "" && props.query !== "";
  let t3;
  if ($[3] !== t0 || $[4] !== t1 || $[5] !== t2) {
    t3 = {
      queryKey: t0,
      queryFn: t1,
      enabled: t2,
      refetchOnWindowFocus: false,
      gcTime: Infinity
    };
    $[3] = t0;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return useQuery(t3);
};
export const useMutationMimirAgentChat = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      mutationFn: mimir.agentChat,
      throwOnError: false,
      retry: 0
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return useMutation(t0);
};